import { useQueryClient } from '@tanstack/react-query';
import { getQueryBaseKey, getQueryKey } from './getQueryKey';
export const getUseSetQueryData = (wrapperOptions) => {
    const useSetQueryData = (params) => {
        const queryClient = useQueryClient();
        const queryKey = params
            ? getQueryKey(wrapperOptions, params)
            : getQueryBaseKey(wrapperOptions, 'query');
        const setQueryData = (updater) => {
            queryClient.setQueriesData({ queryKey }, updater);
        };
        return setQueryData;
    };
    return useSetQueryData;
};
